import { useEffect, useState } from 'react';
import { BaseSelector } from '../../../domain/shared';
import Select from 'react-select';
import { ProductsRepository } from '../../../infrastructure/repositories/products/productRepository';

interface Props {
    onChange: (name: string, value: number | string | undefined) => void;
    value: number | string | undefined;
    name: string;
    isLicensed?: boolean;
}

export default function ProductSelector({ 
    onChange, 
    value, 
    name,
    isLicensed = false
}: Props) {
    const [products, setProducts] = useState<BaseSelector[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);
        
        const fetchProducts = isLicensed
            ? ProductsRepository.GetLicensedProductsList
            : ProductsRepository.GetProductsList;
            
        fetchProducts().then((res) => {
            setIsLoading(false);
            setProducts(
                res.map((c) => ({
                    label: `${c.name} - ${c.type} `,
                    value: c.id,
                }))
            );
        });
    }, [isLicensed]);

    return (
        <div className='mb-2'  >
            <label htmlFor='ubications' className='form-label form-label'>
                Producto
            </label>
            <Select
            
                className='basic-single'
                classNamePrefix='select'
                isLoading={isLoading}
                isSearchable
                name='color'
                options={products}
                onChange={(c) => {
                    onChange(name, c?.value);
                }}
                value={
                    products.find((c) => c.value === value) ?? {
                        label: 'Seleccione',
                        value: 0,
                    }
                }
                menuPortalTarget={document.body}
                menuPosition='fixed'
                styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                }}
            />
        </div>
    );
}
